import { render, staticRenderFns } from "./eu-cookie-law.vue?vue&type=template&id=88d39632&"
import script from "./eu-cookie-law.vue?vue&type=script&lang=js&"
export * from "./eu-cookie-law.vue?vue&type=script&lang=js&"
import style0 from "./eu-cookie-law.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports